export default class Buttons {
	static init() {
		this.buttons = document.querySelectorAll(".btn, .btn-fill, .btn-stroke, .btn-light");

		this.buttons.forEach( (button) => {

			let text = `<span class='label'>${button.innerHTML}</span>`;
			if( button.classList.contains('btn-bigger') ){
				text = `<span class='label-bigger'>${button.innerHTML}</span>`;
			}
			button.innerHTML = text;

			if( button.classList.contains('btn-stroke') ){
				const glossy = document.createElement("span");
				glossy.classList.add("glossy-effect");
				button.classList.add("item-on-hover");
				button.prepend(glossy);
			}

			let elementSvg = "";
			if( button.classList.contains('btn-go') || button.classList.contains('btn-back') ){
				elementSvg = document.createElement("span");
				elementSvg.innerHTML = `<svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.3994 9.89946L9.69227 9.19235L13.435 5.44966H-6.05285e-05V4.44977H13.435L9.69227 0.707074L10.3994 -3.3241e-05L15.3491 4.94971L10.3994 9.89946Z" fill="currentColor"/>
</svg>`;
				elementSvg.classList.add('svg');
				button.appendChild(elementSvg);
			}

			if( button.classList.contains('btn-download') ){
				elementSvg = document.createElement("span");
				elementSvg.innerHTML = `<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.51223 5.64288L0.5 6.63552L7.5 13.5L14.5 6.63552L13.488 5.64288L8.21598 10.8129L8.21598 0.5L6.78441 0.5L6.78441 10.8129L1.51223 5.64288Z"/>
<path d="M2 15H13V16H2V15Z"/>
</svg>`;
				elementSvg.classList.add('svg');
				button.appendChild(elementSvg);
			}

			if( button.classList.contains('btn-gallery') ){
				elementSvg = document.createElement("span");
				elementSvg.innerHTML = `<svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 1H16V10M1 4H13V13H1V4Z" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
				elementSvg.classList.add('svg');
				button.appendChild(elementSvg);
			}

			if( button.classList.contains('btn-lang') ){
				elementSvg = document.createElement("span");
				elementSvg.innerHTML = `<svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.08786 0.982932L8.15892 8.054L7.07107 9.14186L0 2.07079L1.08786 0.982932Z" fill="#34847A"/>
<path d="M14.1422 2.07077L7.07107 9.14186L5.98332 8.05398L13.0544 0.98291L14.1422 2.07077Z" fill="#34847A"/>
</svg>`;
				elementSvg.classList.add('svg');
				button.appendChild(elementSvg);
			}

			if( button.classList.contains('btn-svg-glossy') ){
				const element = document.createElement("span");
				element.classList.add('glossy-effect');
				elementSvg.appendChild(element);
			}

		});

	}

}
